// Solana RPC goes through this site's own Worker (worker/rpcProxy.js), which
// adds the Helius key server-side — so no key ships in the bundle. Same
// origin on every host (app., launchpad., the apex). Off the browser
// (prerendering) there's no origin to use, and nothing makes RPC calls.
const proxied = (network, fallback) =>
  typeof window !== "undefined" && /^https?:$/.test(window.location.protocol)
    ? `${window.location.origin}/api/rpc/${network}`
    : fallback;

export const SOLANA_MAINNET = proxied("mainnet", "https://api.mainnet-beta.solana.com");
export const SOLANA_DEVNET = proxied("devnet", "https://api.devnet.solana.com");
export const SOLANA_TESTNET = "https://api.testnet.solana.com";
